import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Link } from "react-router-dom";

import MalwareDistribution from "../../../Components/PagesComponents/Dashboard/MalwareDistribution/MalwareDistribution";
import CustomTable from "../../../Components/common/Table/CustomTable";
import Card from "../../../Components/common/Card/Card";
import ChartLineIcon from "../../../Components/Icon-SVG/ChartLineIcon";
import ListPopup from "../../../Components/PagesComponents/Dashboard/ListPopup/ListPopup";
import ProxyIcon from "../../../Components/Icon-SVG/ProxyIcon";

import { proxyHeader } from "../../../utils/constants/tableHeaders";

import {
  RequestDailyIntegrationSubmissionCount,
  RequestIntegrationSubmissionCount,
  RequestIntegrationSubmissionState,
} from "../../../store/actions/dashboardActions";

import "./styles.scss";

//GET FILE ID IN URL
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const Icap = () => {
  const licenceCheck = useSelector((state) => state?.users.licenceCheck);
  const submissionsCount = useSelector((state) => state.dashboard.integrationSubmissionCount);
  const dailySubmissionsCount = useSelector(
    (state) => state.dashboard.dailyIntegrationSubmissionCount,
  );
  const cleanState = useSelector((state) => state.dashboard.integrationCleanState);
  const suspiciousState = useSelector((state) => state.dashboard.integrationSuspiciousState);
  const maliciousState = useSelector((state) => state.dashboard.integrationMaliciousState);

  //SET QUERY FOR GETTING DATA ID
  let query = useQuery();
  const [listPopupActive, setListPopupActive] = useState(false);
  const [selectedTimeFilter, setSelectedTimeFilter] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = () => {
      dispatch(RequestIntegrationSubmissionCount("proxy"));
      dispatch(RequestDailyIntegrationSubmissionCount("proxy"));
      dispatch(RequestIntegrationSubmissionState({ timeFilter: "all", integrationType: "proxy" }));
    };

    fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 28000);

    return () => clearInterval(interval);
  }, [dispatch]);

  useEffect(() => {
    if (query.get("data") !== null) {
      setListPopupActive(true);
    } else {
      setListPopupActive(false);
    }
  }, [query]);

  return (
    <div>
      {!licenceCheck?.key && (
        <div className="file-card__content--licence">
          <p>Your license is not active, please update your license key.</p>
          <p>
            Click
            <Link to="/system-info" className="file-card__content--licence-font">
              <span> Here </span>
            </Link>
            to update your license key.
          </p>
        </div>
      )}
      <div className="proxy">
        <div className="proxy__header">
          <h1>ICAP Web / PROXY</h1>
          <p>Detection of malware from web traffics</p>
        </div>
        <div className="proxy__body">
          <div className="proxy__body__logo border ">
            <div className="proxy__body__logo--icon ">
              <ProxyIcon width={150} height={150} />
            </div>
          </div>
          <div className="proxy__body__item">
            <MalwareDistribution
              cleanSubmissionsState={cleanState}
              suspiciousSubmissionsState={suspiciousState}
              maliciousSubmissionsState={maliciousState}
              isIntegration={true}
            />
          </div>
          <table className="border" style={{ height: "208px" }}>
            <thead>
              <tr>
                <th>Proxy Connection Configurations</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Please configure proxy settings provided to you.</td>
              </tr>
            </tbody>
          </table>
          <div className="proxy__body__card">
            <Card
              title="Daily Download"
              value={dailySubmissionsCount}
              icon={<ChartLineIcon width={18} height={17} color={"white"} />}
            />
            <Card
              title="Total Download"
              value={submissionsCount}
              icon={<ChartLineIcon width={18} height={17} color={"white"} />}
            />
          </div>
        </div>
        <div className="proxy__table border" style={{ width: "100%", minHeight: "40.5rem" }}>
          <CustomTable
            exportFile={true}
            column={proxyHeader}
            tableName={"icapweb"}
            leftAction={false}
            tableFolder={"icapweb"}
            isSetUrl
            paginationButtons={true}
            className=""
            minBottom="-36px"
            customPageSize={10}
            minHeightRow="72px"
            paginationHeight="36px"
            paginationBackColor="var(--card-background-color)"
            paginationBorder={true}
            manualPagination={true}
            filterByTime={true}
            selectedTimeFilter={selectedTimeFilter}
            setSelectedTimeFilter={setSelectedTimeFilter}
          />
        </div>
      </div>

      <ListPopup
        onClickOk={() => setListPopupActive(false)}
        show={listPopupActive}
        groupID={query.get("data")}
        tableType={query.get("table")}
        tableType2="icapweb"
      />
    </div>
  );
};
export default Icap;
